namespace Matrix.Indexation {
    export interface DimBasketConstituentRow {
        BasketConstituentKey?: number;
        BasketIndexKey?: number;
        ConstituentIndexKey?: number;
        Generation?: number;
        IsCurrent?: string;
        EffectiveFrom?: string;
        EffectiveTo?: string;
        Weight?: number;
        HedgeRatio?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        DefaultSortOrder?: number;
        BasketIndexKeyIndexCode?: string;
        BasketIndexKeyName?: string;
        BasketIndexKeyGeneration?: number;
        BasketIndexKeyIsCurrent?: string;
        BasketIndexKeyEffectiveFrom?: string;
        BasketIndexKeyEffectiveTo?: string;
        BasketIndexKeyLocalCurrencyCode?: string;
        BasketIndexKeyIndexTypeCode?: string;
        BasketIndexKeyPriceSource1?: string;
        BasketIndexKeyPriceSource1Id?: string;
        BasketIndexKeyPriceSource2?: string;
        BasketIndexKeyPriceSource2Id?: string;
        BasketIndexKeyFxOtherCurrency?: string;
        BasketIndexKeyRowId?: number;
        BasketIndexKeyDefaultSortOrder?: number;
        ConstituentIndexCode?: string;
        ConstituentIndexName?: string;
        ConstituentIndexGeneration?: number;
        ConstituentIndexIsCurrent?: string;
        ConstituentIndexEffectiveFrom?: string;
        ConstituentIndexEffectiveTo?: string;
        ConstituentIndexLocalCurrencyCode?: string;
        ConstituentIndexTypeCode?: string;
        ConstituentIndexPriceSource1?: string;
        ConstituentIndexPriceSource1Id?: string;
        ConstituentIndexPriceSource2?: string;
        ConstituentIndexPriceSource2Id?: string;
        ConstituentIndexFxOtherCurrency?: string;
        ConstituentIndexRowId?: number;
        ConstituentIndexDefaultSortOrder?: number;
    }

    export namespace DimBasketConstituentRow {
        export const idProperty = 'BasketConstituentKey';
        export const localTextPrefix = 'Indexation.DimBasketConstituent';
        export const deletePermission = 'Administration:Genera';
        export const insertPermission = 'Administration:Genera';
        export const readPermission = 'Administration:Genera';
        export const updatePermission = 'Administration:Genera';

        export declare const enum Fields {
            BasketConstituentKey = "BasketConstituentKey",
            BasketIndexKey = "BasketIndexKey",
            ConstituentIndexKey = "ConstituentIndexKey",
            Generation = "Generation",
            IsCurrent = "IsCurrent",
            EffectiveFrom = "EffectiveFrom",
            EffectiveTo = "EffectiveTo",
            Weight = "Weight",
            HedgeRatio = "HedgeRatio",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            DefaultSortOrder = "DefaultSortOrder",
            BasketIndexKeyIndexCode = "BasketIndexKeyIndexCode",
            BasketIndexKeyName = "BasketIndexKeyName",
            BasketIndexKeyGeneration = "BasketIndexKeyGeneration",
            BasketIndexKeyIsCurrent = "BasketIndexKeyIsCurrent",
            BasketIndexKeyEffectiveFrom = "BasketIndexKeyEffectiveFrom",
            BasketIndexKeyEffectiveTo = "BasketIndexKeyEffectiveTo",
            BasketIndexKeyLocalCurrencyCode = "BasketIndexKeyLocalCurrencyCode",
            BasketIndexKeyIndexTypeCode = "BasketIndexKeyIndexTypeCode",
            BasketIndexKeyPriceSource1 = "BasketIndexKeyPriceSource1",
            BasketIndexKeyPriceSource1Id = "BasketIndexKeyPriceSource1Id",
            BasketIndexKeyPriceSource2 = "BasketIndexKeyPriceSource2",
            BasketIndexKeyPriceSource2Id = "BasketIndexKeyPriceSource2Id",
            BasketIndexKeyFxOtherCurrency = "BasketIndexKeyFxOtherCurrency",
            BasketIndexKeyRowId = "BasketIndexKeyRowId",
            BasketIndexKeyDefaultSortOrder = "BasketIndexKeyDefaultSortOrder",
            ConstituentIndexCode = "ConstituentIndexCode",
            ConstituentIndexName = "ConstituentIndexName",
            ConstituentIndexGeneration = "ConstituentIndexGeneration",
            ConstituentIndexIsCurrent = "ConstituentIndexIsCurrent",
            ConstituentIndexEffectiveFrom = "ConstituentIndexEffectiveFrom",
            ConstituentIndexEffectiveTo = "ConstituentIndexEffectiveTo",
            ConstituentIndexLocalCurrencyCode = "ConstituentIndexLocalCurrencyCode",
            ConstituentIndexTypeCode = "ConstituentIndexTypeCode",
            ConstituentIndexPriceSource1 = "ConstituentIndexPriceSource1",
            ConstituentIndexPriceSource1Id = "ConstituentIndexPriceSource1Id",
            ConstituentIndexPriceSource2 = "ConstituentIndexPriceSource2",
            ConstituentIndexPriceSource2Id = "ConstituentIndexPriceSource2Id",
            ConstituentIndexFxOtherCurrency = "ConstituentIndexFxOtherCurrency",
            ConstituentIndexRowId = "ConstituentIndexRowId",
            ConstituentIndexDefaultSortOrder = "ConstituentIndexDefaultSortOrder"
        }
    }
}
